export default {
  rate_us: "Bewerte uns & erhalte gratis Essen",
};
